export default __webpack_public_path__ + "static/media/record5.4c53ce51.png";